module.exports = __webpack_public_path__ + "static/img/4734_phase_function_Paper_Points.0ffa849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4734_phase_function_Paper_Points.png
// module id = sVtf
// module chunks = 0